import Phaser from 'phaser';
import { store } from '../stores/mainStore';
import {angleBetweenPoints, getDistance, pointAlongLine} from './helpers';

export class Cup {
	cupClicked = false;
	cupSprite = null;
	handPointer = null;
	handPointerTimer = null;
	cupNoticeMeTimer = null;
	cupSwirlTimer = null;
	waitForFTUE = false;

	constructor(mng, diceHand) { 
		this.m = mng; this.scene = this.m.scene
		this.diceHand = diceHand;

		this.cupHomeposition = { x: this.m.config.width *0.33, y: this.m.config.height * 0.75};
		this.outHomeposition = { x: -100, y: this.m.config.height + 100};
		//this.cupReleasePosition = this.cupHomeposition;
		//this.cupDownPosition = this.cupReleasePosition;

		this.aimPoint = { x: this.m.config.width / 2, y: this.m.config.height * 0.5 };
			}

	create() {
		const m = this.m, scene = this.scene;
		const screenWidth = m.config.width;
		const screenHeight = m.config.height;

		this.cupSprite = scene.add.sprite(this.outHomeposition.x, this.outHomeposition.y, 'cup_sheet')
			//.setInteractive({draggable: true})
			.setFrame(1).setOrigin(0.5, 0.05)
		this.cupScale = 180 / this.cupSprite.width * m.scaleFactor;
		this.cupSprite.setScale(m.scaleFactor)
		this.cupHeight = this.cupSprite.displayHeight;

		this.arrowSprite = scene.add.sprite(this.cupHomeposition.x, this.cupHomeposition.y, 'common', 'cupArrow.png')
			.setOrigin(0.5, 1.1).setScale(m.scaleFactor, 0);

		this.cupSwirl = scene.add.sprite(this.outHomeposition.x, this.outHomeposition.y, 'swirl001')
			.setScale(m.oldAssetScaleFactor).setOrigin(0.5, 0.275);

		this.waitForHandPointer = false;
		this.pointCupTowardsAimPoint();

		//scene.input.setDraggable(this.cupSprite);
		scene.input.dragDistanceThreshold = 1;
		scene.input.dragTimeThreshold = 1;
		scene.input.on('drag', (pointer, gameObject, dragX, dragY) => {
			if (gameObject !== this.cupSprite)  return;
			if (this.waitForHandPointer === true) return;
			//if (this.waitForFTUE === true)	return;
			//if(store.tutorialMode && !this.cupClicked)	return;
			if(!this.cupClicked)	return;
			if (['introToCup', 'launch', 'launching'].includes(this.diceHand.diceStatus)) return;

			this.clearHandPointer(m);

			if (store.tutorialMode && m.skipTutorial != null) 
				m.skipTutorial.setAlpha(0);

			const flickDistance = -this.cupHeight / 2;
			const pullDistance = screenHeight - this.cupHeight / 2 - this.cupHomeposition.y;
			if (this.cupSprite.y >= this.cupHomeposition.y + flickDistance * 1.0)
				gameObject.x = dragX;

			if (dragY >= this.cupHomeposition.y + flickDistance && dragY <= this.cupHomeposition.y + pullDistance) {
				gameObject.y = dragY;
			}
			this.pointCupTowardsAimPoint();

			const x = pointer.position.x;
			const y = pointer.position.y;
			const left = x < (store.tutorialMode ? 40 : 20);
			const right = x > screenWidth - (store.tutorialMode ? 40 : 40);
			const bottom = y > screenHeight - this.cupHeight * 0.3;
			const high = dragY < screenHeight * 0.15;
				if (left || right || bottom || high) {
				this.processCupPointerUp();//left ? 'LEFT' : right ? 'RIGHT' : bottom ? 'BOTTOM' : 'HIGH');
					return;
				}

			var inBounds = Phaser.Geom.Rectangle.ContainsPoint(this.cupSprite.getBounds(), pointer.position);
				if (inBounds === false) {
				this.processCupPointerUp();//'DRAG_OUT');
					return;
				}
		});

		this.cupSprite.on('dragstart', pointer => {
			if (this.waitForHandPointer === true) return;
			//if(store.tutorialMode && !this.cupClicked)	return	//adamo cuptest
			if(!this.cupClicked)	return;

			this.clearHandPointer(m)

			if (!this.cupClicked) this.processPointerDown(pointer);
		});
		this.cupSprite.on('dragend', _pointer => {
			if (this.diceHand.diceStatus === 'introToCup') return;
			if (m.readyToLaunch || this.diceHand.diceStatus !== 'arrivedInCup') return;
			if(!this.cupClicked)	return;

			this.processCupPointerUp();//'DRAGEND');
		});

		this.cupSprite.on('pointerdown', pointer => {
			this.processPointerDown(pointer);
					});
		this.cupSprite.on('pointerup', (_pointer, gameObj) => {
			if(!this.cupClicked)	return;
			this.processCupPointerUp();//'CUP_POINTERUP');
		});
		this.cupSprite.on('pointerout', pointer => {
			pointer = scene.input.activePointer;
			});

		this.hideCup();
		this.hideCupSwirl();
		}

	appear(full = true) {
		this.diceHand.clearDiceOffScreen();

		full ? this.showDiceInCup() : this.hideDiceInCup();
		const angle = this.setPositionOutScreen();
		const onAnimComplete = () => {
			if(this.m.gameState !== 'userPlay') 
				this.m.gameState = 'userPlay';
			this.startCupNoticeMeTimer();
			this.enable();
	}
		this.scene.tweens.add({ targets: [this.cupSprite],
			x: this.cupHomeposition.x, y: this.cupHomeposition.y, angle: angle,
			ease: 'Linear', duration: 300,
			onComplete: () => {
				if(!full) {
					this.createCupOverlay();
					const tinyDeltaX = -5 * this.m.scaleFactor;
					const tinyDeltaY = 28 * this.m.scaleFactor; 
					this.diceHand.fallDiceIntoCup(
						this.cupHomeposition.x + tinyDeltaX,
						this.cupHomeposition.y + tinyDeltaY,
						() => {
							this.removeCupOverlay();
							this.showDiceInCup();
							onAnimComplete();
	}
					)
		} else {
					onAnimComplete();
					this.startCupNoticeMeTimer(100)
	}

	}
		})
	}

	processPointerDown() {
		if(this.m.gameState !== 'userPlay')		return

		this.cupSprite.input.draggable = true;
		this.cupClicked = true;
		this.cupDownPosition = { x: this.cupSprite.x, y: this.cupSprite.y };

		this.clearCupNoticeMeTimer()
		this.clearHandPointer()
		this.cupSwirlTimer = gameSetTimeout(this.showCupSwirl, 400);

		this.m.gameState = 'bet';
					}
	processCupPointerUp(forced = false) {
		this.cupClicked = false;
		this.arrowSprite.setScale(this.m.scaleFactor, 0);
		this.hideCupSwirl();
		this.disable();

		if(!forced)	{	// start dice rolling
			this.m.playAudio('diceRoll');
			this.cupThrow();
		}
	}
	cupThrow = () => {
		// cup moves a little ahead to throw dice out
		this.cupReleasePosition = { x: this.cupSprite.x, y:this.cupSprite.y };
		const distance = getDistance(this.cupSprite.x, this.cupSprite.y, this.aimPoint.x, this.aimPoint.y);
		const maxDistance = getDistance(this.m.farthestLaunchPoint.x, this.m.farthestLaunchPoint.y, this.aimPoint.x, this.aimPoint.y);
		this.cupPower = Math.max(0.3, Math.min(distance / maxDistance, 0.9));
		const travel = Math.min(0.9, (this.cupHeight * 1.5) / distance);
		const targetPoint = pointAlongLine(travel, this.cupSprite.x, this.cupSprite.y, this.aimPoint.x, this.aimPoint.y);

		this.scene.tweens.add({	targets: [this.cupSprite],
			x: targetPoint.x, y: targetPoint.y,
			ease: 'Linear', duration: 50,
			onComplete: () => {
				this.hideDiceInCup();
				this.diceHand.throwDiceFromCup(this.cupSprite.x, this.cupSprite.y)
				this.moveCupFromScreen();
				}
		});
	}

	getDiceStartVelocity = (ind) => {
		const vel = 170* this.cupPower * (1 + 0.25*Math.random())
		let rnd = Math.random() * 60;
		if (Math.random() < 0.5) rnd = -rnd;
		var dX = this.cupReleasePosition.x - this.aimPoint.x + rnd;
		var dY = this.cupReleasePosition.y - this.aimPoint.y;
		dX = dX / dY; // ((Math.abs(dX) / Math.abs(dY)));
		dY /= Math.abs(dY);
		return { x: -dX * vel, y: -dY * vel};
	}
	moveCupFromScreen = () => {
		const distance = getDistance(this.cupSprite.x, this.cupSprite.y, this.aimPoint.x, this.aimPoint.y);
		const maxDistance = getDistance(0, this.m.config.height + this.cupSprite.height * 1.5, this.aimPoint.x, this.aimPoint.y);
		const targetPoint = pointAlongLine( maxDistance / distance,
			this.aimPoint.x, this.aimPoint.y,
			this.cupSprite.x, this.cupSprite.y
		);
		this.scene.tweens.add({targets: [this.cupSprite],
			x: targetPoint.x, y: targetPoint.y,
			ease: 'Linear', duration: 900,
			onComplete: () => this.hideCup()
			});
			}

	enable() {
		this.cupSprite.setInteractive({draggable: true});
		this.scene.input.setDraggable(this.cupSprite);
		}
	disable() {
		this.cupSprite.disableInteractive();
		this.scene.input.setDraggable(this.cupSprite, false);
	}

	handPointerFlick = false;
	showHandPointer() {
		this.clearHandPointer()

		if(store.activeMatch.matchId === 'tutorial') {
			this.waitForHandPointer = false;
			return;
		}
		if (this.diceHand.diceStatus !== 'resolved' ||
			Math.floor(this.cupSprite.x) !== Math.floor(this.cupHomeposition.x) ||
			Math.floor(this.cupSprite.y) !== Math.floor(this.cupHomeposition.y)
		)
			return;
		if (store.activeMatch.handNumber === 3 && store.activeMatch.currentHand.rollNumber > 0) return;

		const m = this.m;
		this.handPointerFlick = !this.handPointerFlick;
		this.handPointer = this.scene.add.container(this.cupHomeposition.x, this.cupHomeposition.y);

		const cupOutline = this.scene.add.sprite(0, 0, 'common', 'cupOutline.png')
			.setOrigin(0.47, 0.15).setScale(this.cupSprite.scale)
			.setAngle(this.cupSprite.angle)
		this.handPointer.add(cupOutline);

		const pointerHand = this.scene.add.sprite(
			(this.cupHomeposition.x > m.config.width / 2 ? 110 : 70) * m.scaleFactor, 
			120 * m.scaleFactor, 'hand'
		).setScale(0.65 * m.scaleFactor);
		this.handPointer.add(pointerHand);
		pointerHand.anims.play('handPoint');

		this.waitForHandPointer = false;
		const offX = delta => this.cupHomeposition.x > m.config.width / 2 ? +-delta : delta;
		if (this.handPointerFlick) {
			const targetX = offX(50);
			const targetY = -this.cupSprite.height;
			this.scene.tweens.add({ targets: [cupOutline],
				x: targetX, y: targetY,
				ease: 'Linear', delay: 1000, duration: 150,
				onComplete: () => {
					if (store.tutorialMode && store.activeMatch.matchId === 'intro') 
						this.waitForHandPointer = false;
					if (store.tutorialMode && store.activeMatch.matchId === 'intro2') 
						this.waitForHandPointer = false;

					const tx = targetX + 10* Math.sign(this.cupHomeposition.x - m.config.width/2)
					const ty = -this.cupSprite.height * 0.75;
					this.scene.tweens.add({ targets: [cupOutline],
						x: tx, y: ty,	duration: 150,
						ease: 'Linear', yoyo: true,
						onComplete: () => {
							this.handPointerTimer = gameSetTimeout(this.showHandPointer, 1000);
						},
					});
				},
			});
			const targetX2 = pointerHand.x + offX(50);
			const targetY2 = pointerHand.y - m.cup.cupSprite.height;
			this.scene.tweens.add({ targets: [pointerHand],
				x: targetX2, y: targetY2,
				ease: 'EaseOut', delay: 1000, duration: 150,
				onComplete: () =>  pointerHand.setFrame(0)
			});
		} else {
			var oldX = cupOutline.x, oldY = cupOutline.y;
			this.scene.tweens.add({ targets: [cupOutline],
				x: offX(60), y: this.cupSprite.height,
				ease: 'EaseOut', delay: 1000, duration: 500,
				onComplete: () => {
					if (store.tutorialMode && store.activeMatch.matchId === 'intro') 
						this.waitForHandPointer = false;
					if (store.tutorialMode && store.activeMatch.matchId === 'intro2') 
						this.waitForHandPointer = false;
					m.scene.tweens.add({ targets: [cupOutline],
						x: oldX, y: oldY,
						ease: 'Linear', delay: 250, duration: 250,
						onComplete: () => {
							this.handPointerTimer = gameSetTimeout(this.showHandPointer, 1000);
						},
					});
				},
			});
			const targetX2 = pointerHand.x + offX(60);
			const targetY2 = pointerHand.y + m.cup.cupSprite.height;
			const oldX2 = pointerHand.x, oldY2 = pointerHand.y;
			this.scene.tweens.add({ targets: [pointerHand],
				x: targetX2, y: targetY2,
				ease: 'EaseOut', delay: 1000, duration: 500,
				onComplete: () => {
					pointerHand.setFrame(0);
					this.scene.tweens.add({ targets: [pointerHand],
						x: oldX2, y: oldY2,
						ease: 'Linear', delay: 750, duration: 750,
					});
				},
			});
		}
	}
	clearHandPointer = () => {
		if (this.handPointer) {
			if (this.handPointerTimer) 		clearTimeout(this.handPointerTimer);
			this.handPointer.destroy();
		}
	}

	createCupOverlay = () => {
		this.cupOverlay = this.scene.add.sprite(this.cupHomeposition.x - 1, this.cupHomeposition.y, store.custom.cup + '_cup_sheet')
			.setFrame(5).setScale(this.cupSprite.scale)
			.setAngle(this.cupSprite.angle)
			.setOrigin(0.5, 0.05).setDepth(5);
	}
	removeCupOverlay = () => {
		this.cupOverlay.destroy();
	}

	startCupNoticeMeTimer(time) {
		if(store.tutorialMode && (store.activeMatch.matchId === 'intro2' || store.activeMatch.matchId === 'intro'))
			return;
		this.cupSprite.setScale(this.cupScale);
		this.cupNoticeMeTimer = gameSetTimeout(this.doCupNoticeMeTimer, 
			time ? time : store.tutorialMode ? 5000 : 60000
		);
	}
	doCupNoticeMeTimer = () => {
		if (this.cupNoticeMeTimer != null) {
			this.cupSprite.setScale(this.cupScale);
			this.scene.tweens.add({
			targets: [this.cupSprite],
				scale: this.cupScale * 1.2,
				ease: 'Linear',	yoyo: true,
				duration: 150, 
				repeat: 1, repeatDelay: 50,
			onComplete: () => {
					this.cupSprite.setScale(this.cupScale);
					this.startCupNoticeMeTimer();	//restart it
				}
		});
		}
	}
	clearCupNoticeMeTimer() {
		this.cupSprite.setScale(this.cupScale);
		if (this.cupNoticeMeTimer != null) {
			clearTimeout(this.cupNoticeMeTimer);
			this.cupNoticeMeTimer = null;
		}
	}

	showCupSwirl = () => {
		if (!this.cupSwirl) return;
		this.cupSwirl.x = this.cupSprite.x;
		this.cupSwirl.y = this.cupSprite.y;
		this.cupSwirl.angle = this.cupSprite.angle;
		this.cupSwirl.setAlpha(1.0);
		this.cupSwirl.anims.play('cupSwirl');

		this.pointCupTowardsAimPoint();
	}
	hideCupSwirl() {
		if (!this.cupSwirl) return;
		if (this.cupSwirlTimer != null) {
			clearTimeout(this.cupSwirlTimer);
			this.cupSwirlTimer = null;
		}
		this.cupSwirl.setAlpha(0);
		if (!this.cupSwirl.anims) return;
		this.cupSwirl.anims.stop();

		this.arrowSprite.setScale(1.5 * this.m.scaleFactor, 0);
	}

	pointCupTowardsAimPoint() {
		const m = this.m;
		this.cupSprite.angle = angleBetweenPoints({ x: this.cupSprite.x, y: this.cupSprite.y }, this.aimPoint) - 90;
		this.arrowSprite.x = this.cupSprite.x;
		this.arrowSprite.y = this.cupSprite.y;
		this.arrowSprite.angle = this.cupSprite.angle;
		const distance = getDistance(this.cupSprite.x, this.cupSprite.y, this.aimPoint.x, this.aimPoint.y);
		const maxDistance = getDistance(m.farthestLaunchPoint.x, m.farthestLaunchPoint.y, this.aimPoint.x, this.aimPoint.y);
		const scale = Math.max(0.5 * m.scaleFactor, Math.min(1.75 * m.scaleFactor,
				distance / maxDistance * 2.0*m.scaleFactor))

		if (this.cupSwirl?.alpha > 0) this.arrowSprite.setScale(1.5 * m.scaleFactor, scale);
		this.cupSwirl.x = this.cupSprite.x;
		this.cupSwirl.y = this.cupSprite.y;
		this.cupSwirl.angle = this.cupSprite.angle;
	}

	showDiceInCup() {
		/* //show same cup w/ little dice showing
		if (this.frameNum < 6) 
			this.setFrame(this.frameNum + 6);  */
		this.cupSprite.setFrame(this.getCupFrame(true));
	}
	hideDiceInCup() {
		/* //show same cup w/ no little dice showing
		if (this.frameNum >= 6) 
			this.setFrame(this.frameNum - 6);  */
		this.cupSprite.setFrame(this.getCupFrame(false));
	}
	// later may be more rules (roll num, bonus, etc)
	getCupFrame = withDice => withDice ? 10 : 4;

	get isAtScreen () { return this.cupSprite.x > 0 && this.cupSprite.x < this.m.config.width}
	hideCup = () => {
		const cfg = this.m.config
		this.cupSprite.x = this.cupSprite.x > cfg.width / 2 ? cfg.width + 400 : -400;
		this.cupSprite.y = cfg.height + 400;
	}
	setPositionOutScreen = () => {
		const cupOffset = 0.33;
		//this.cupHomeposition.x = this.cupSprite.x > this.m.config.width / 2 ? this.m.config.width * (1.0 - cupOffset) : this.m.config.width * cupOffset;
		this.cupHomeposition.x = this.m.config.width * cupOffset;
		const angle = angleBetweenPoints({ x: this.cupHomeposition.x, y: this.cupHomeposition.y }, this.aimPoint) - 90;
		this.cupSprite.x = this.cupSprite.x > this.m.config.width/2 ? this.m.config.width + 100 : -100;
		this.cupSprite.y = this.m.config.height + 100;
		return angle
	}

}